/**************************************************
 * Nombre:       Tarjeta_Tema
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Estadistica = ({resultado}) => {
    const {sCell} = useResponsive()
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#ffffff20',
                backdropFilter: 'blur(3px)',
                borderRadius: 4,
                border: 1,
                borderColor: '#ffffff90',
                py: 3,
                px: sCell ? 2 : 3,
                boxShadow: '1px 4px 26px 0px rgba(0, 0, 0, 0.15)'
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                <img src={resultado.icono} style={{width: '40%', height: 'auto'}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} alignItems={'center'}
                  sx={{mt: 1, justifyContent: 'center', minHeight: sCell ? 64 : 38}}>
                <Typography sx={{
                    fontWeight: 800,
                    fontSize: 16,
                    lineHeight: 1.2,
                    textAlign: 'center',

                }}>{resultado.nombre}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Estadistica